export default __webpack_public_path__ + "i18n/pt-BR.05369ed7f6a341d6331c0a0c0c92dd3f.json";